import { render, staticRenderFns } from "./CreateSettlementNoKasbonMultiPerEmployee.vue?vue&type=template&id=5871d3e0"
import script from "./CreateSettlementNoKasbonMultiPerEmployee.vue?vue&type=script&lang=js"
export * from "./CreateSettlementNoKasbonMultiPerEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports